<template>
    <div v-if="webAppNames.length == 0">
        <v-card class="mt-10 mx-auto" max-width="1280">
            <InstallationGuide/>
        </v-card>
    </div>
    <div v-else>
        <Drawer
            :drawerStatus="assetViewDrawerStatus"
            drawerWidth='80%'
            zIndex=100
            v-on:onDismiss="assetViewDrawerStatus = 'collapsed'"
            v-on:onOverlayClicked="assetViewDrawerStatus = 'collapsed'"
            :title="selectedAssetKey"
            :subtitle="'@' + selectedAssetCollection"
            >
            <AssetView
                :assetKey='selectedAssetKey'
                :drawerStatus="assetViewDrawerStatus"
            ></AssetView>
        </Drawer>
        <v-row>
            <v-col cols="10" justify="space-between">
                <h2 class="text-uppercase font-weight-light">
                    Business Tracking Analysis                    
                    <TimePeriodSelection
                        buttonText="Contrast to"
                        :defaultSelection="getContrastTimeSelection"
                        v-on:onTimePeriodSelected="onContrastTimePeriodSelected"/>
                </h2>
            </v-col>
            <v-col cols="2">
                <AutoRefresh class="mt-n4" v-on:onRefresh="onRefresh"/>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col>
                <v-card>
                    <v-card-title>
                        <v-row no-gutters>
                            <v-col cols="4">
                                <v-text-field
                                    clearable
                                    v-model="search"
                                    append-icon="mdi-magnify"
                                    label="Search by asset ID"
                                    single-line
                                    hide-details
                                    @input="onSearchChange"
                                    @click:clear="onClearSearch"
                                    @keydown.enter="onSearch">
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-data-table
                        :headers="assetListHeaders"
                        :items="assets"
                        :search="search"
                        :options.sync="options"
                        :server-items-length="totalAssets"
                        :loading="loading"
                        item-key="web_txn_id"
                        single-select
                        @click:row="handleAssetTableClick">
                            <template v-slot:item.created_at="{ item }">
                                {{ toLongFormatWithYear(item.created_at) }}
                            </template>
                            <template v-slot:item.updated_at="{ item }">
                                {{ toLongFormatWithYear(item.updated_at) }}
                            </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>

    </div>

</template>
<script>
    import { mapGetters, mapActions } from 'vuex'
    import TimeHelper from '@/helpers/time_helper'
    import Api from '@/services/api'
    import TimePeriodSelection from '@/components/TimePeriodSelection.vue'
    import AutoRefresh from '@/components/AutoRefresh.vue'
    import Drawer from '@/components/Drawer.vue'
    import AssetView from '@/components/AssetView.vue'
    import InstallationGuide from '@/components/InstallationGuide.vue'

    export default {
        components: {
            TimePeriodSelection, AutoRefresh, Drawer, AssetView, InstallationGuide
        },

        name: 'AssetTrackingTable',

        props: {
        },

        watch: {
            options: {
                handler () {
                    if (!this.loading) {
                        this.getAssetList()
                    }
                },
                deep: true,
            },
            currentWebAppName: function (newWebAppName, oldWebAppName) {
                this.getAssetList();
            }
        },


        mounted: function() {
            if (this.hasSubscription && this.currentWebAppName) {
                this.getAssetList();
            } else {
                console.log("No subscription or data collectors. Data fetching is stopped.")
            }
        },

        computed: {
            ...mapGetters([
                'getContrastTimeSelection',
                'webAppNames',
                'currentWebAppName',
            ]),
            ...mapGetters('auth', {
                hasSubscription: 'hasSubscription'
            }),            
        },

        methods: {
            ...TimeHelper,

            ...mapActions([
                'setContrastTimeSelection',
            ]),      

            onSearchChange: function() {
                if (this.search == '') {
                    this.getAssetList();
                }
            },

            onClearSearch: function() {
                this.search = '';
                this.getAssetList();
            },

            onSearch: function(event) {
                this.options.page = 1;
                this.getAssetList();
            },

            getAssetList: function() {
                this.loading = true
                Api.assets.getAssetList(
                    {
                        ...this.options,
                        search: this.search
                    }                    
                )
                .then((response1) => {
                    console.log("Asset list: ", response1.data)
                    this.loading = false
                    this.assets = response1.data
                    this.totalAssets = this.assets.length > 0 ? parseInt(this.assets[0].total) : 0
                })
            },

            onContrastTimePeriodSelected: function(numOfMinutesAgo) {
                this.setContrastTimeSelection(numOfMinutesAgo);
            },

            onRefresh: function() {
            },

            handleAssetTableClick: function(item, row) {
                console.log("Selected asset:", item);
                row.select(true);                
                this.selectedAsset = item
                this.selectedAssetKey = item.key_content
                this.selectedAssetCollection = item.collection
                this.assetViewDrawerStatus = 'expanded'
            }
        },

        data: () => ({
            search: '',
            assets: [],
            options: {
                sortBy: ['updated_at'],
                sortDesc: [true],
                mustSort: true
            },
            totalAssets: 0,
            loading: false,
            assetListHeaders: [
                { text: 'Asset ID', align: 'start', value: 'key_content', width: 200 },
                { text: 'Channel', value: 'channel_name', width: 160 },
                { text: 'Collection', value: 'collection', width: 100 },
                { text: 'Creation Time', value: 'created_at', width: 100 },
                { text: 'Created By', value: 'created_by', width: 110 },
                { text: 'Time Since Creation (hrs)', value: 'time_since_creation_in_hr', width: 160 },
                { text: 'Last Update Time', value: 'updated_at', width: 100 },
                { text: 'Last Updated By', value: 'updated_by', width: 110 },
            ],
            selectedAsset: null,
            selectedAssetKey: null,
            selectedAssetCollection: null,
            assetViewDrawerStatus: 'collapsed',

        }),
    }

</script>

<style scoped lang="scss">

</style>